import React, { Component } from 'react';
import { Row } from 'reactstrap';

class Page extends Component {
  render() {

    return (
      <Row className={'h-100 page ' + this.props.className} style={this.props.style}>
        {this.props.children}
      </Row>
    );
  }
}

export default Page;
